<script lang="ts">
    import { Col } from "sveltestrap";
    import { CardFooter, Title } from "../../../utils/Constant/Constant";
    import Card from "../Card.svelte";
</script>

<Col sm="12">
    <Card
        cardHeaderProps="pb-0 d-flex align-items-center justify-content-between"
        headerTitle={Title}
        footercontent={CardFooter}
        contentBody="Start creating your amazing application!"
    />
</Col>
